import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class TagServices {
  getTags = async (orgId, entityName, page, limit, searchKeyword) => {
    let url = `${Constants.TAG}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (entityName) url += `entity_name=${entityName}&`;
    if (limit) url += `limit=${limit}&`;
    if (page) url += `page=${page}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    const tags = await Helpers.get({ url });
    return tags;
  }

  createTag = async (payload) => {
    const tag = await Helpers.post({
      url: `${Constants.TAG}`,
      data: payload,
    });
    return tag;
  }
}

export default new TagServices();
